import { useState } from 'react';

interface ReplyingState {
    id: string;
    message: string;
    username: string;
}

export const useReplying = () => {
    const [replying, setReplying] = useState<ReplyingState | undefined>(
        undefined,
    );

    const onReply = (meta: ReplyingState) => setReplying(meta);

    const onCancel = () => setReplying(undefined);

    const resetReplying = () => setReplying(undefined);

    return { onCancel, onReply, replying, resetReplying };
};
